import React, { useCallback } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory, useLocation } from 'react-router-dom';

import { Container } from './styles';
import KrHome from '../KoroIcons/KrHome';

interface IProps {
  className?: string;
}

const ButtonHome: React.FC<IProps> = ({ className }) => {
  const history = useHistory();
  const location = useLocation();

  const handleHome = useCallback(() => {
    history.push('/');
  }, [history]);

  return (
    <Container
      type="button"
      disabled={location.pathname.includes('visualizacao')}
      onClick={handleHome}
      className={`d-flex align-items-center bg-transparent border-0 ${className}`}
    >
      Home <KrHome size={12} color="#878787" className="ms-2" />
    </Container>
  );
};

export default ButtonHome;
